import React from "react";
import { Result, Button } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error("ErrorBoundary caught an error:", error, errorInfo);

    // Check if it's a localStorage quota error
    if (error.name === "QuotaExceededError" || error.message.includes("quota")) {
      console.warn("localStorage quota exceeded, clearing...");
      // Clear problematic localStorage data
      try {
        localStorage.removeItem("redux_localstorage_simple");
        localStorage.removeItem("purchaseOrdersFilters");
        localStorage.removeItem("purchaseOrderShipmentsFilters");
      } catch (e) {
        console.error("Failed to clear localStorage:", e);
      }
    }

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  handleReload = () => {
    // Clear localStorage and reload
    try {
      localStorage.removeItem("redux_localstorage_simple");
      localStorage.removeItem("purchaseOrdersFilters");
      localStorage.removeItem("purchaseOrderShipmentsFilters");
    } catch (e) {
      console.error("Failed to clear localStorage:", e);
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Er is een fout opgetreden"
          subTitle="Klik op de knop hieronder om door te gaan."
          extra={[
            <Button type="primary" key="reload" onClick={this.handleReload}>
              Herladen en doorgaan
            </Button>,
          ]}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
